import { useCustomerUserDetail } from "@/api/services/main/customer-user";
import { DetailPageLayout } from "@/components/commons/DetailPageLayout";
import { EllipsisText } from "@/components/elements/EllipsisText";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { BasicInfoSection } from "@/features/customer-user/components/detail/BasicInfoSection";
import { DetailFooter } from "@/features/customer-user/components/detail/DetailFooter";
import { ProductAccessSection } from "@/features/customer-user/components/detail/ProductAccessSection";
import { UserStatusSection } from "@/features/customer-user/components/detail/UserStatusSection";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { FC } from "react";
import { Navigate, useParams } from "react-router-dom";

export const CustomerUserDetailPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: user, isLoading } = useCustomerUserDetail(id);

  if (isLoading) return <LoadingArea height={400} />;
  if (!user) return <Navigate to={AppRoutes.pageNotFound} replace />;

  return (
    <DetailPageLayout
      title="ユーザー情報"
      description="ユーザーの詳細情報です。"
      menuPrefix={
        <EllipsisText title={user.fullName} variant="body14Bold" color={text.primary} maxWidth={168} sx={{ px: "16px", py: "8px" }} />
      }
      contents={[
        { title: "ユーザーの状態", content: <UserStatusSection user={user} /> },
        { title: "基本情報", content: <BasicInfoSection user={user} /> },
        { title: "プロダクトアクセス権限", content: <ProductAccessSection user={user} /> },
      ]}
      footer={<DetailFooter user={user} />}
    />
  );
};
